import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface BuyMusicChannelResponse extends MiddlewareAPIResponse
{

}

export class BuyMusicChannelResponseDtoImpl extends MiddlewareDtoImpl implements BuyMusicChannelResponse
{
    
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/wishlist/buymusicchannel/buymusicchannelresponse.tsx